import { render, staticRenderFns } from "./FundingRounds.vue?vue&type=template&id=2fc081ec&scoped=true&"
import script from "./FundingRounds.vue?vue&type=script&lang=js&"
export * from "./FundingRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc081ec",
  null
  
)

export default component.exports